import React from 'react';
import PropTypes from 'prop-types';
import ReviewDetailsContent from 'Components/Modals/IdentityVerificationReviewDetails/reviewDetailsContent';
import ReviewDecisionContent from 'Components/Modals/IdentityVerificationReviewDetails/decisionContent';

const types = {
  REVIEW: 'IdentityVerificationReview',
  DECISION: 'IdentityVerificationDecision',
};

const getContent = (resource, rest) => {
  const headResourceType = resource?.type();

  switch (headResourceType) {
    case types.REVIEW:
      return <ReviewDetailsContent resource={resource} {...rest} />;
    case types.DECISION:
      return <ReviewDecisionContent resource={resource} {...rest} />;
    default:
      return null;
  }
};

const DialogContentPicker = ({ resource, ...rest }) => {
  const contentComponent = getContent(resource, rest);

  return (
    contentComponent
  );
};

DialogContentPicker.propTypes = {
  resource: PropTypes.object.isRequired,
  onDecisionMade: PropTypes.func.isRequired,
  onDecisionSubmitted: PropTypes.func.isRequired,
};

export default DialogContentPicker;
